/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { EmployeeModel } from '../models/employee-model';
import { getClientRep$Json } from '../fn/client-rep/get-client-rep-json';
import { GetClientRep$Json$Params } from '../fn/client-rep/get-client-rep-json';
import { getClientRep$Plain } from '../fn/client-rep/get-client-rep-plain';
import { GetClientRep$Plain$Params } from '../fn/client-rep/get-client-rep-plain';
import { getClientReps$Json } from '../fn/client-rep/get-client-reps-json';
import { GetClientReps$Json$Params } from '../fn/client-rep/get-client-reps-json';
import { getClientReps$Plain } from '../fn/client-rep/get-client-reps-plain';
import { GetClientReps$Plain$Params } from '../fn/client-rep/get-client-reps-plain';

@Injectable({ providedIn: 'root' })
export class ClientRepService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getClientReps()` */
  static readonly GetClientRepsPath = '/api/ClientRep';

  /**
   * get all clientrep.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClientReps$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientReps$Plain$Response(params?: GetClientReps$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmployeeModel>>> {
    return getClientReps$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get all clientrep.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getClientReps$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientReps$Plain(params?: GetClientReps$Plain$Params, context?: HttpContext): Observable<Array<EmployeeModel>> {
    return this.getClientReps$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EmployeeModel>>): Array<EmployeeModel> => r.body)
    );
  }

  /**
   * get all clientrep.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClientReps$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientReps$Json$Response(params?: GetClientReps$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmployeeModel>>> {
    return getClientReps$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get all clientrep.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getClientReps$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientReps$Json(params?: GetClientReps$Json$Params, context?: HttpContext): Observable<Array<EmployeeModel>> {
    return this.getClientReps$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EmployeeModel>>): Array<EmployeeModel> => r.body)
    );
  }

  /** Path part for operation `getClientRep()` */
  static readonly GetClientRepPath = '/api/ClientRep/{clientRepId}';

  /**
   * get clientrep by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClientRep$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientRep$Plain$Response(params: GetClientRep$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeModel>> {
    return getClientRep$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get clientrep by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getClientRep$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientRep$Plain(params: GetClientRep$Plain$Params, context?: HttpContext): Observable<EmployeeModel> {
    return this.getClientRep$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<EmployeeModel>): EmployeeModel => r.body)
    );
  }

  /**
   * get clientrep by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClientRep$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientRep$Json$Response(params: GetClientRep$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeModel>> {
    return getClientRep$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get clientrep by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getClientRep$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientRep$Json(params: GetClientRep$Json$Params, context?: HttpContext): Observable<EmployeeModel> {
    return this.getClientRep$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<EmployeeModel>): EmployeeModel => r.body)
    );
  }

}
